var map = {
	"./HC.png": 77809,
	"./almacen.png": 89545,
	"./ev_medica.png": 11103,
	"./grafica.png": 81095,
	"./kardex.png": 97315,
	"./monitoreo.png": 12414,
	"./note.png": 39050,
	"./rp.png": 1864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78961;